<!-- Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com -->
<!-- See license file. -->
<script setup lang="ts">
import TemplateList from "@/components/templates/TemplateList.vue";
import type { TemplateCategory } from "@/types";
const props = defineProps<{
  category: TemplateCategory;
}>();
</script>

<template>
  <TemplateList :category="props.category" :canAdd="true" :canEdit="true" />
</template>

<style lang="scss"></style>
